import script from "./edit.vue?vue&type=script&setup=true&name=editProject&lang=js"
export * from "./edit.vue?vue&type=script&setup=true&name=editProject&lang=js"

import "./edit.vue?vue&type=style&index=0&id=de8a19b6&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de8a19b6"]])

export default __exports__